import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest, enhancedApiRequest } from "../../../utils";

const API_PAYMENTS = `${ACCOUNT_SERVICE}/payments`;

export const payments = {
  getAll: async ({
    filters,
    top,
    skip,
    sort,
    params,
    signal,
    enableCaching,
  } = {}) => {
    const options = await apiOptions({
      url: API_PAYMENTS,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });

    return enhancedApiRequest(
      options,
      {},
      {
        enableCaching,
      }
    );
  },
  getById: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_PAYMENTS}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_PAYMENTS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getCreateOptions: async ({ data }) =>
    apiOptions({
      url: API_PAYMENTS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    }),
  update: async ({ id, data, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_PAYMENTS}/${id}`,
      method: "patch",
      data: { ...data, modifiedOn },
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  getUpdateOptions: async ({ id, data, modifiedOn }) =>
    apiOptions({
      url: `${API_PAYMENTS}/${id}`,
      method: "patch",
      data: { ...data, modifiedOn },
      headers: { [X_API_VERSION]: API_VERSION },
    }),
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_PAYMENTS}/${id}`,
      method: "delete",
      data: { modifiedOn },

      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
